// noinspection ES6PreferShortImport,JSUnusedGlobalSymbols

import { DocumentData, FieldValue, Timestamp } from "../extern/FirebaseTypes"

export enum UserRole {
    USER = 'USER',
    COMPANY_OWNER = 'COMPANY_OWNER',
    ADMIN = 'ADMIN'
}

export interface IdData<T> {
    id: string
    data: T
}

export interface TimestampData extends DocumentData {
    createdTimestamp: Timestamp|FieldValue
    [field: string]: any
}

export interface IsActiveNoTimestampData {
    isActive: boolean
}

export interface IsActiveData extends TimestampData, IsActiveNoTimestampData {
}

export interface User {
    id: string
    data: UserData
}

export interface UserData extends IsActiveData {
    firstName: string
    firstNameLower: string
    lastName: string
    lastNameLower: string
    name: string
    nameLower: string
    email: string
    companyId?: string
    role: UserRole
    isTester?: boolean                  // true for permanent test accounts
    isTemp?: boolean                    // true for temporary accounts
    tempAccessCodeId?: string           // for temp accounts
    stripeSubscriptionIds?: string[]
}

export interface AccessCode {
    id: string
    data: AccessCodeData
}

export interface AccessCodeData extends IsActiveData {
    createdByUserId: string
    name: string
    nameLower: string
    accessEndTimestamp: Timestamp       // end for temp accounts
}

export interface Company {
    id: string
    data: CompanyData
}

export interface CompanyData extends IsActiveData {
    name: string
    nameLower: string
    email: string
    address?: AddressData
    stripeCustomerId: string
}

export interface AddressData extends DocumentData {
    line1: string
    line2?: string
    city: string
    state: string
    country: string
    postalCode: string
}

export interface ZipCodeData extends DocumentData {
    cities: ZipCodeCityData[]
    states: string[] // unique state abbreviations of all cities
}

export interface ZipCodeCityData extends DocumentData {
    state: string // state abbreviation
    stateName: string
    county: string
    city: string
}

export enum ApiKeyMode {
    UNK = 'UNK',
    DEV = 'DEV',
    PROD = 'PROD',
}

export interface ApiKey {
    id: string                          // id = api key
    data: ApiKeyData
}

export interface ApiKeyData extends IsActiveData {
    companyId: string
    mode: ApiKeyMode
    name: string
}

export interface MetadataEquipmentData {
    formatVersion: number
    changeVersion: number
}